/** An address arrives as a string or as a Shopify-style object; show it on one line. */
export function formatAddress(address: unknown): string | undefined {
  if (!address) return undefined;
  if (typeof address === 'string') return address;
  if (typeof address !== 'object') return undefined;
  const a = address as Record<string, unknown>;
  const parts = [a.address1, a.address2, a.city, a.province ?? a.state, a.zip ?? a.pincode].filter((p) => typeof p === 'string' && p);
  if (!parts.length) return undefined;
  const name = typeof a.name === 'string' && a.name ? `${a.name} · ` : '';
  return name + parts.join(', ');
}
